
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Yonex-Sunrise G H Raisoni Memorial MH Sub Junior(U-15, U-17) State Selection Badminton Tournament 2025 </h1>
				</div>
			</div>
		</div>
	</div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
    <div class="container">
        <div class="row justify-content-between">
            <div class="col-md-12">
              <!-- <div class="sec-title">
                <h2><span>Yonex-Sunrise G H Raisoni Memorial MH Sub Junior(U-15, U-17) State Selection Badminton Tournament 2025</span></h2>
              </div> -->
              <p>The G H Raisoni Memorial Badminton Tournament 2025, supported by Raisoni Foundation, brought together Maharashtra’s finest U-15 and U-17 players in a spirited contest of skill, focus, and determination.</p>

            </div>


        </div>

        <div class="col-lg-12">
            <div class="gall-ery">
                <div class="row">
                    <div class="col-md-8">
                        <div class="widget_title inner-title gall-sys shadow-text-sm">
                            <h4 class="fw-bold">Photos</h4>
                        </div>
                    </div>
                    <div class="col-md-4 text-end">
                        <!-- <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/swiming-meet.pdf" target="_blank" class="btn button--effect-1 v-more"><span>
                                View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
                        </a> -->
                    </div>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                        <li
                            class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/u17-u15-badminton-turnament.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/u17-u15-badminton-turnament.webp"
                        >
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/u17-u15-badminton-turnament.webp" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li
                            class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/u17-u15-badminton-turnament1.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/u17-u15-badminton-turnament1.webp"
                        >
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/u17-u15-badminton-turnament1.webp" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li
                            class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/u17-u15-badminton-turnament2.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/u17-u15-badminton-turnament2.webp"
                        >
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/u17-u15-badminton-turnament2.webp" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li
                            class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/u17-u15-badminton-turnament4.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/u17-u15-badminton-turnament4.webp"
                        >
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/u17-u15-badminton-turnament4.webp" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li
                            class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/u17-u15-badminton-turnament5.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/u17-u15-badminton-turnament5.webp"
                        >
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/u17-u15-badminton-turnament5.webp" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                        <li
                            class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/u17-u15-badminton-turnament3.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/u17-u15-badminton-turnament3.webp"
                        >
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/u17-u15-badminton-turnament3.webp" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

    </div>

</section>

